import axiosService from './axios.service';
import ResponseService from './response.service';

const fiatList = async (
  _perPage,
  _page,
  _commonSearch,
  _date,
  _type,
  _status,
  _field,
  _order,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'transactions/fiat',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: _commonSearch,
        date: _date,
        type: _type,
        status: _status,
        sortBy: _field,
        sortOrder: _order,
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const onChainList = async (
  _perPage,
  _page,
  _commonSearch,
  sortBy,
  projectId,
  _type,
  _field,
  _order,
  includeAll,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'transactions/onchain',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: _commonSearch,
        projectId: projectId,
        type: _type,
        sortBy: _field,
        sortOrder: _order,
        includeAll: includeAll,
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const downloadPDF = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'transactions/generate_transaction_pdf',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};
// generate pdf for tax overview
const downloadTaxOverviewPDF = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'tax_overview/generate_pdf',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const getTaxOverviewList = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'tax_overview/list',
      isAuthorized: true,
    };
    const _response = await axiosService.hit(axiosData);
    return _response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const TransactionService = {
  fiatList,
  onChainList,
  downloadPDF,
  downloadTaxOverviewPDF,
  getTaxOverviewList,
};

export default TransactionService;
